<template>
  <div>
    <slot name="label-container">
      <div :style="labelStyle">
        <slot name="label" />
      </div>
    </slot>
    <BaseSelect ref="base-select"
                v-bind="$attrs"
                v-on="myListeners"
                :byClick="true"
                :checkSymbolStyle="checkSymbolStyle"
                :initSelectedOptionIndex="initSelectedOptionIndex"
                :open="show"
                :optionContainerStyle="optionContainerStyle"
                :options="options"
                :optionStyle="optionStyle"
                :selectContainerStyle="selectContainerStyle"
                :selectStyle="selectStyle"
                :toggle="toggle"
                @click-outside="close"
                @popover-updated="popoverUpdated"
                @select="selectOption">
      <template v-slot:select>
        <slot name="select" />
      </template>
      <template v-slot:expand-symbol>
        <BaseGoogleIcon v-bind="expandIconStyle"
                        content="expand_more" />
      </template>
      <template v-slot:options-top>
        <slot name="options-top" />
      </template>
      <template v-slot:options-bottom>
        <slot name="options-bottom" />
      </template>
      <template v-slot:symbol-selected>
        <BaseGoogleIcon v-bind="selectedIconStyle"
                        content="check" />
      </template>
      <template v-slot:symbol-not-selected>
        <div :style="optionSymbolStyle" />
      </template>
    </BaseSelect>
  </div>
</template>

<script>
  import BaseGoogleIcon from '@base/base-google-icon'
  import BaseSelect from '@base/base-select'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SelectPrimary',
    inheritAttrs: false,
    components: {
      BaseGoogleIcon,
      BaseSelect,
    },
    props: {
      initSelectedOptionIndex: { type: Number, required: false, default: null },
      options: { type: Array, required: true },
    },
    data: function () {
      return {
        show: false,
        toggle: false,
        optionContainerWidth: null,
        optionSymbolStyle: {
          width: '24px',
        },
      };
    },
    mounted: function () {
      this.optionContainerWidth = this.$refs['base-select'].$refs['select-container'].offsetWidth + 'px';
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      checkSymbolStyle: function () {
        return {
          width: '24px',
          minWidth: '24px',
        };
      },
      expandIconStyle: function () {
        return {
          fontSize: '14px',
          iconStyle: {
            color: this.color.dark3(),
            fontSize: '14px',
          },
        };
      },
      labelStyle: function () {
        return {
          color: this.color.dark3(),
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.lg,
          marginBottom: Layout.space.sm,
        };
      },
      myListeners: function () {
        const { select, ...listeners } = this.$listeners;
        return listeners;
      },
      optionContainerStyle: function () {
        return {
          backgroundColor: this.color.shadow1(),
          border: 'none',
          borderRadius: 'none',
          borderWidth: 'none',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
          maxHeight: '320px',
          overflow: 'hidden',
          overflowY: 'scroll',
          padding: `8px 0`,
          width: this.optionContainerWidth,
          ...this.$attrs.optionContainerStyle,
        };
      },
      optionStyle: function () {
        return {
          backgroundColor: {
            '': this.color.shadow1(),
            hover: this.color.dark6(),
            active: this.color.dark6(),
            disabled: this.color.dark4(),
          },
          color: this.color.dark2(),
          cursor: { '': 'pointer', disabled: 'default' },
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: {
            '': FontStyle.weight.md,
            selected: FontStyle.weight.lg,
          },
          height: '32px',
          lineHeight: '32px',
          ...this.$attrs.optionStyle,
        };
      },
      selectContainerStyle: function () {
        return {
          backgroundColor: this.color.shadow1(),
          border: {
            '': `solid ${this.color.dark5()}`,
            open: `solid ${this.color.dark2()}`,
          },
          borderRadius: '4px',
          borderWidth: '1px',
          boxSizing: 'border-box',
          lineHeight: '14px',
          padding: `${Layout.space.sm} ${Layout.space.md}`,
        };
      },
      selectedIconStyle: function () {
        return {
          display: 'block',
          fontSize: '14px',
          iconStyle: {
            color: this.color.dark3(),
            fontSize: '14px',
          },
          paddingLeft: '5px',
          width: '24px',
        };
      },
      selectStyle: function () {
        return {
          color: this.color.dark3(),
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
        };
      },
    },
    methods: {
      close: function () {
        if (this.show) {
          this.toggle = !this.toggle;
        }
      },
      popoverUpdated: function (show) {
        this.show = show;
      },
      selectOption: async function (index) {
        await this.close();
        this.$emit('select', index);
      },
    },
  };
</script>
